import React from 'react'
import { Card, CardText, CardTitle, CardHeader, CardActions } from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import get from 'lodash/get'
import upperCase from 'lodash/upperCase'

import Spacer from '../spacer'
import FileInput from '../file-input'
import api from '../../api'

const cardActionsStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
  padding: '14px 0',
  marginRight: -8
}

class BulkImporter extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      file: null,
      errors: null,
      result: null,
      template: null
    }
  }

  handleFileSelection = file => {
    this.setState({ file })
  }

  handleSubmit = () => {
    const { file } = this.state
    const formData = new window.FormData()
    formData.append('file', file, file.name)

    api.postFile(this.props.uploadPath, { body: formData })
      .then(res => res.json())
      .then(data => {
        this.setState({
          file: null,
          errors: data.errors,
          result: data.result
        })
      })
  }

  createTemplate = () => {
    api.post(this.props.templatePath)
      .then(res => res.json())
      .then(template => {
        this.setState({
          template
        })
      })
  }

  closeTemplateDialog = () => {
    this.setState({
      template: null
    })
  }

  render () {
    const { file, errors, result } = this.state

    return (
      <div>
        <CardActions style={cardActionsStyle}>
          <RaisedButton onClick={this.createTemplate} label='Create Template' />
        </CardActions>

        {
          this.state.template &&
            <Dialog
              title='Download CSV Template'
              modal={false}
              open={this.state.template !== null}
              actions={[
                <FlatButton
                  label='Close'
                  primary
                  onClick={this.closeTemplateDialog}
                />
              ]}
              onRequestClose={this.closeTemplateDialog}
            >
              <a href={this.state.template.url}>
                {this.state.template.filename}
              </a>
            </Dialog>
        }

        <CardTitle title={this.props.title} style={{ paddingLeft: 0 }} />
        <p>
          {this.props.children}
        </p>
        <FileInput
          accept='text/csv'
          label='Select CSV'
          onFileSelected={this.handleFileSelection}
        />
        <span style={{ paddingLeft: '15px' }}>{get(file, 'name')}</span>
        {
          file &&
            <div>
              <Spacer />
              <RaisedButton
                label='Import'
                primary
                onClick={this.handleSubmit}
              />
            </div>
        }

        <Spacer />

        {
          result &&
            <Card>
              <CardHeader title='Import Results' />
              <CardText>
                <strong>Errors</strong>
                {
                  errors && errors.length === 0 &&
                    <p>
                      <em>No errors</em>
                    </p>
                }

                {
                  errors && errors.length > 0 &&
                    <ul>
                      {
                        errors.map(error => (
                          <li><strong>LINE {error.line}</strong>{get(error, 'data.Email') && ` (${error.data.Email})`}: {error.message}</li>
                        ))
                      }
                    </ul>
                }
                <strong>Stats</strong>
                <ul>
                  {
                    result &&
                  Object.keys(result).map(key => (
                    <li>
                      <strong>{upperCase(key)}:</strong> {result[key]}
                    </li>
                  ))
                  }
                </ul>
              </CardText>
            </Card>
        }
      </div>
    )
  }
}

// @ts-ignore
BulkImporter.propTypes = {
  title: React.PropTypes.string.isRequired,
  children: React.PropTypes.node.isRequired,
  uploadPath: React.PropTypes.string.isRequired,
  templatePath: React.PropTypes.string.isRequired
}

export default BulkImporter
